import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import '../public/idnex.css'
const app = createApp(App)
import improtElement from './plugins/element'
improtElement(app)
import 'element-plus/dist/index.css'


app.use(store).use(router).mount('#app')
